import { environment } from './../../../environments/environment';
import { tap } from 'rxjs/operators';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

export class TimingInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();
    return next
      .handle(req).pipe(
        tap((event) => {
          if (event instanceof HttpResponse) {
            const elapsed = Date.now() - started;
            if (!environment.production) {
              console.log(`Request for ${req.urlWithParams} took ${elapsed} ms.`);
            }
          }
        }));
  }
}
